import React, { Component } from 'react';
import { getUser, updateUser, authStatus } from '../../modules/users';
import { connect } from 'react-redux';
import styles from './UserProfile.module.css';
import ImportForm from '../../components/ImportForm';
import Button from '../../components/Button';
import { setView } from '../../modules/explorer';

class UserProfile extends Component {
  state = {
    schema: [
      { key: 'name', label: 'Name' },
      { key: 'email', label: 'Email' },
      { key: 'jobTitle', label: 'Job Title' },
      { key: 'employer', label: 'Company' },
      { key: 'city', label: 'City' },
      { key: 'country', label: 'Country' },
      { key: 'gravatar', label: 'Gravatar Email' },
    ],
    formData: {},
    successMsg: null,
    errorMsg: null,
  };

  onChange = (key, value) => {
    const { formData } = this.state;
    formData[key] = value;
    this.setState({ formData });
  };

  updateUser = async () => {
    const { formData } = this.state;
    const { updateUser } = this.props;
    const result = await updateUser(formData);
    if (result && result.status === 'ok') {
      this.setState({ successMsg: 'Changes saved', errorMsg: null });
    } else {
      this.setState({
        successMsg: null,
        errorMsg: (result && result.message) || 'Failed to save changes',
      });
    }
  };

  async componentDidMount() {
    const { authStatus } = this.props;
    await authStatus();
    const { user } = this.props;
    const { setView } = this.props;
    const { schema, formData } = this.state;
    for (let i in schema) {
      const key = schema[i].key;
      if (key === 'email') {
        if (user.emailsVerified.length > 0)
          formData[key] = user.emailsVerified[0];
      } else {
        formData[key] = user[key];
      }
    }
    setView({
      page: 'userview',
      catogary: 'users',
      activeLabel: 'edit',
    });
    this.setState({ formData });
  }

  componentWillUnmount() {
    const { setView } = this.props;
    setView({ page: null, catogary: null });
  }

  render() {
    const { user } = this.props;
    if (!user) return null;
    const { schema, formData, successMsg, errorMsg } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.title}> {user.username} </div>
        <div className={styles.description}>
          <div className={styles.descriptionText}> {user.jobTitle} </div>
          <div className={styles.descriptionText}>{user.employer} </div>
          <div className={styles.descriptionText}>
            {' '}
            {user.city}, {user.country}{' '}
          </div>
        </div>
        <div className={styles.inputContainer}>
          <ImportForm
            schema={schema}
            formData={formData}
            onChange={this.onChange}
          />
          <div className={styles.btnContainer}>
            <Button text="Save Changes" onClick={this.updateUser} />
          </div>
          {successMsg && <div className={styles.successMsg}>{successMsg}</div>}
          {errorMsg && <div className={styles.errorMsg}> {errorMsg} </div>}
        </div>
      </div>
    );
  }
}

const stateToProps = state => ({
  user: getUser(state),
});

export default connect(
  stateToProps,
  { updateUser, setView, authStatus }
)(UserProfile);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/index.js